/**
 * Gravity Forms — CSP-safe button handlers
 *
 * Gravity Forms puts its submit/next/previous behaviour in an inline
 * onclick="" attribute. This site's CSP carries a nonce, which makes browsers
 * ignore 'unsafe-inline', and inline event handlers are not covered by a nonce
 * — so the attribute never fires and the button does nothing. The PHP side
 * (functions/gravity-forms-csp.php) strips the attribute; this re-binds the
 * exact same call from an external script, which CSP permits.
 *
 * Delegated from the document so it also covers forms that Gravity Forms
 * re-renders over AJAX (page transitions, validation errors, confirmations).
 */

const SELECTOR = "button[data-submission-type]";

/**
 * Run Gravity Forms' own click handler for a button.
 * @param {HTMLElement} button
 * @returns {boolean} Whether the handler could be called.
 */
function runGravityHandler(button) {
  const gf = window.gform;

  if (gf && gf.submission && typeof gf.submission.handleButtonClick === "function") {
    gf.submission.handleButtonClick(button);
    return true;
  }

  return false;
}

/**
 * Last resort if Gravity Forms' JS never arrived: submit the form natively so
 * the visitor is not stuck on a dead button. GF degrades to a normal POST.
 * @param {HTMLElement} button
 */
function fallbackSubmit(button) {
  const form = button.closest("form");
  if (!form) return;

  // Tell GF which button was used, the way its own markup would have.
  const type = button.dataset.submissionType;
  if (type === "next" || type === "previous") {
    const target = form.querySelector('input[name^="gform_target_page_number_"]');
    const source = form.querySelector('input[name^="gform_source_page_number_"]');
    if (target && source) {
      const current = parseInt(source.value || "1", 10);
      target.value = String(type === "next" ? current + 1 : Math.max(1, current - 1));
    }
  }

  form.submit();
}

document.addEventListener("click", (event) => {
  const button = event.target.closest(SELECTOR);

  if (!button) return;

  // Only handle buttons whose inline handler we removed, so any GF button that
  // still carries its own onclick is left completely alone.
  if (button.dataset.gfCspBind !== "1") return;

  event.preventDefault();

  if (!runGravityHandler(button)) {
    fallbackSubmit(button);
  }
});

/**
 * Rebind Gravity Forms' radio "Other" toggle.
 *
 * GF ships this as onchange="gformToggleRadioOther( this )" on every radio
 * input, which CSP blocks. The PHP side swaps it for a data attribute.
 */
document.addEventListener("change", (event) => {
  const input = event.target;

  if (!input || input.dataset.gfCspRadioOther !== "1") return;

  if (typeof window.gformToggleRadioOther === "function") {
    window.gformToggleRadioOther(input);
  }
});

